import { Tooltip } from "antd";
import styles from "./style.module.less";

export const ClosedDot = () => {
    return (
        <div className={styles.closedDot}>
            <Tooltip placement="top" title="Closed">
                <i className="ri-record-circle-fill"></i>
            </Tooltip>
        </div>
    );
}